// DO NOT EDIT: autogenerated by brokkr
import { CreateIconOptions } from "./types";
export const falChartLineUp: CreateIconOptions = {
  "displayName": "FALChartLineUp",
  "viewBox": "0, 0, 512, 512",
  "d": "M32 48c0-8.8-7.2-16-16-16S0 39.2 0 48L0 400c0 44.2 35.8 80 80 80l416 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L80 448c-26.5 0-48-21.5-48-48L32 48zm288 96c0 8.8 7.2 16 16 16l89.4 0L320 265.4l-84.7-84.7c-6.2-6.2-16.4-6.2-22.6 0l-112 112c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L224 214.6l84.7 84.7c6.2 6.2 16.4 6.2 22.6 0L448 182.6l0 89.4c0 8.8 7.2 16 16 16s16-7.2 16-16l0-128c0-8.8-7.2-16-16-16l-128 0c-8.8 0-16 7.2-16 16z"
};
